module.exports = __webpack_public_path__ + "img/cmp-tab-inactive-history.9bc52a77.svg";